import React, { Component } from "react";

export default class SeniorenplatformItemTable extends Component {
    constructor(props){
        super();

        this.showDetails = this.showDetails.bind(this);
    }

    showDetails(){
        this.props.getDetailsOfItem(this.props.item.urlName);
    }
    toggleIsFavorites = (event) => {
        event.stopPropagation();
        this.props.toggleIsFavorites(this.props.item);
    }

    render(){
        return(
            <div className="c-senioren__tableview--item" onClick={this.showDetails}>
                <div className="c-senioren__tableview--item-top">
                    <span className="name">{this.props.item.name}</span>
                    {/* <span className="time">10:00</span> */}
                </div>
                <div className="c-senioren__tableview--item-bottom">
                    <span className="category">{this.props.item.category}</span>
                    <div className={`c-senioren__button c-senioren__button--favorite ${this.props.item.isFavorite === true ? "c-senioren__button c-senioren__button--favorite--active" : ""}`}
                             onClick={this.toggleIsFavorites}>
                            <div className="icon">
                                {this.props.item.isFavorite !== null && this.props.item.isFavorite !== true ? 
                                    <i class="fa-regular fa-heart"></i>
                                    : 
                                    <i class="fa-solid fa-heart"></i>                                                          
                                }   
                            </div> 
                        </div>
                </div>
            </div>
        );
    }
}
